import React from 'react'

function Alerts(props) {
    // here capitalize function is used to capitalize the first letter of the alert type and make the rest of the letters lowercase. firslty we convert all char in lower then chosing the first char then converting to uppercase and slice uses to slice from 1 to n index added to character
    const capitalize = (word) => {  
        const lower = word.toLowerCase();
        return lower.charAt(0).toUpperCase()+lower.slice(1);
    }
  return (
    <div style={{height: '50px'}}>
    {//props.alert &&  is used to check if the alert is not null and then it will display the alert message and type of alert in the alert box. The alert box will be displayed only when the alert is not null. The alert box will be dismissed when the close button is clicked. 
    // The alert box will be displayed for 1.5 seconds and then it will be dismissed automatically.
    props.alert &&  <div className={`alert alert-${props.alert.type} alert-dismissible fade show`} role="alert">
    <strong>{capitalize(props.alert.type)}</strong> : {props.alert.msg}
  </div>}
    </div>

  )
}

export default Alerts
